(function (angular, app) {
    'use strict';

    app.service('PermanentViewFiltersDialog', ['mDesign', function(mDesign) {
        this.show = show;

        function show() {
            return mDesign.dialog({
                templateUrl: 'views/templates/permanent-view-filters/index.html',
                controller: 'PermanentViewFiltersCtrl as permanentViewFiltersCtrl',
                resolve: {
                    PermanentFiltersGroups: ['PermanentFiltersGroups', function (PermanentFiltersGroups) {
                        return PermanentFiltersGroups.create();
                    }]
                }
            });
        }
    }]);

    app.run(['$rootScope', 'PermanentViewFiltersDialog', function ($rootScope, PermanentViewFiltersDialog) {
        $rootScope.PermanentViewFiltersDialog = PermanentViewFiltersDialog;
    }]);

    app.controller('PermanentViewFiltersCtrl', [
        '$q', '$timeout', 'Api', 'Retailer', 'SpProductTags', 'mDesign', 'User','Config', 'PermanentFilters', 'PermanentFiltersGroups', 'PRODUCT_TAG_ID', 'DELIVERY_MODE_TOGGLE',
        function($q, $timeout, Api, Retailer, SpProductTags, mDesign,User,Config, PermanentFilters, PermanentFiltersGroups, PRODUCT_TAG_ID, DELIVERY_MODE_TOGGLE) {
            var permanentViewFiltersCtrl = this,
                _totalGroups,
                _loadPromise;

            permanentViewFiltersCtrl.groups = [];
            permanentViewFiltersCtrl.loadGroups = loadGroups;
            permanentViewFiltersCtrl.clearAll = clearAll;
            permanentViewFiltersCtrl.save = save;
            permanentViewFiltersCtrl.close = mDesign.hide;
            permanentViewFiltersCtrl.selectedProductTags = PermanentFilters.values[PermanentFilters.TYPES.PRODUCT_TAGS].reduce(function(obj, value) {
                obj[value] = true;
                return obj;
            }, {});

            Retailer.getRetailerSettings().then(function (configuration) {
                permanentViewFiltersCtrl.retailer = configuration;
            });

            loadGroups();

            function loadGroups() {
                if (_loadPromise || _totalGroups !== undefined && permanentViewFiltersCtrl.groups.length >= _totalGroups) {
                    return;
                }

                var _isEnableExpressDeliveryToggle = _getIsEnableExpressDeliveryToggle();

                _loadPromise = PermanentFiltersGroups.get(permanentViewFiltersCtrl.groups.length, 3).then(function(result) {
                    _totalGroups = result.total;
                    var allowedUsers = Config.retailer.settings.eBTAllowedUsers ? JSON.parse(Config.retailer.settings.eBTAllowedUsers) : [];
                    if (allowedUsers.length && !allowedUsers.includes(User.settings.id)) {
                        angular.forEach(result.groups, function (group) {
                            if (!group.productTags || !group.productTags.length) return;

                            var _productTags = [];
                            for (var i = 0; i < group.productTags.length; i++) {
                                var _tag = angular.copy(group.productTags[i]);

                                if (_tag.productTagId === PRODUCT_TAG_ID.EBT_ELIGIBLE || _tag.productTagId === PRODUCT_TAG_ID.EBT_CASH_ELIGIBLE) continue;

                                _tag.isDisabled = _getIsDiabledFilter(_tag, { isExpressFilterActive: _isEnableExpressDeliveryToggle });
                                _productTags.push(_tag);
                            }

                            group.productTags = _productTags;
                        });
                    } else if (allowedUsers.length && allowedUsers.includes(User.settings.id)) {
                        angular.forEach(result.groups, function (group) {
                            if (!group.productTags || !group.productTags.length) return;

                            var _productTags = [];
                            for (var i = 0; i < group.productTags.length; i++) {
                                var _tag = angular.copy(group.productTags[i]);

                                if (_tag.productTagId === PRODUCT_TAG_ID.EBT_CASH_ELIGIBLE) continue;

                                _tag.isDisabled = _getIsDiabledFilter(_tag, { isExpressFilterActive: _isEnableExpressDeliveryToggle });
                                _productTags.push(_tag);
                            }

                            group.productTags = _productTags;
                        });
                    }

                    Array.prototype.push.apply(permanentViewFiltersCtrl.groups, result.groups);
                }).finally(function() {
                    _loadPromise = undefined;
                });
            }

            function clearAll() {
                var _isEnableExpressDeliveryToggle = _getIsEnableExpressDeliveryToggle();

                angular.forEach(permanentViewFiltersCtrl.selectedProductTags, function(val, productTagId) {
                    var _isDisabled = _getIsDiabledFilter( { productTagId: productTagId }, { isExpressFilterActive: _isEnableExpressDeliveryToggle });
                    if(!_isDisabled){
                        delete permanentViewFiltersCtrl.selectedProductTags[productTagId];
                    }
                });

                return save();
            }

            function save() {
                var productTagIds = [];
                angular.forEach(permanentViewFiltersCtrl.selectedProductTags, function(val, productTagId) {
                    if (val) {
                        productTagIds.push(Number(productTagId));
                    }
                });

                permanentViewFiltersCtrl.saving = true;
                return $q.all([
                    PermanentFilters.addProductTagsFilters(productTagIds, true),
                    $timeout(function(){}, 1000)
                ]).then(function() {
                    permanentViewFiltersCtrl.saved = true;

                    if (!productTagIds.length) {
                        mDesign.hide();
                    }
                }).finally(function() {
                    permanentViewFiltersCtrl.saving = false;
                });
            }

            function _getIsEnableExpressDeliveryToggle() {
                return Number(localStorage.getItem('mobileZuzModeToggle')) === DELIVERY_MODE_TOGGLE.EXPRESS_DELIVERY;
            }

            function _getIsDiabledFilter(filterItem, options) {
                var _options = options || {};
                if(_options.isExpressFilterActive && Number(filterItem.productTagId) === PRODUCT_TAG_ID.EXPRESS_DELIVERY) return true;

                return false;
            }
        }
    ]);
})(angular, angular.module('mobilezuz'));
